module.exports = __webpack_public_path__ + "static/media/vandijk.f7800743.png";